
export const getCommercialTypeColor = (type: string) => {
  switch (type) {
    case "Sale":
      return "bg-blue-100 text-blue-800";
    case "Lease":
      return "bg-green-100 text-green-800";
    case "Collaborate":
      return "bg-purple-100 text-purple-800";
    case "Stake":
      return "bg-amber-100 text-amber-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getAgencyColor = (agency: string) => {
  switch (agency) {
    case "GSA":
      return "bg-red-100 text-red-800";
    case "Education":
      return "bg-blue-100 text-blue-800";
    case "NOAA":
      return "bg-cyan-100 text-cyan-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};
